import { HttpClient } from "@angular/common/http";
import { ApiResponse } from "src/app/shared/interfaces/api-response.interface";
import { Injectable } from "@angular/core";
import { first, Observable } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { FamiliaImpressaoRequest, ImpressaoDet, ImpressaoGrupoRequest, GrupoImpressaoResponse } from "src/app/shared/models/impressora-config.model";
import { FamiliaResponse } from "src/app/shared/models/produto.model";

@Injectable({
    providedIn: 'root'
})
export class ImpressaoService {
    constructor(
        private authService: AuthenticationService,
        private http: HttpClient
    ) { }

    private get base() {
        return `${this.authService.baseUrl}/Impressao`;
    }

    public getAll(): Observable<ApiResponse<GrupoImpressaoResponse[]>> {
        return this.http.get<ApiResponse<GrupoImpressaoResponse[]>>(`${this.base}/getAll`).pipe(
            first()
        );
    }

    public alterarItemFamilia(familia: FamiliaImpressaoRequest): Observable<ApiResponse<FamiliaImpressaoRequest>> {
        return this.http.post<ApiResponse<FamiliaImpressaoRequest>>(`${this.base}/adicionar`, familia).pipe(
            first()
        );
    }

    public deletarItemFamilia(familia: FamiliaImpressaoRequest): Observable<ApiResponse<FamiliaImpressaoRequest>> {
        return this.http.delete<ApiResponse<FamiliaImpressaoRequest>>(`${this.base}/deletarFamilia/${familia.codFamilia}`).pipe(
            first()
        );
    }

    public alterarImpressao(impressao: ImpressaoGrupoRequest) {
        return this.http.put<ApiResponse<ImpressaoGrupoRequest>>(`${this.base}/AlterarImpressao`, impressao).pipe(
            first()
        );
    }

    public adicionarImpressao(impressao: ImpressaoGrupoRequest) {
        return this.http.post<ApiResponse<ImpressaoGrupoRequest>>(`${this.base}`, impressao).pipe(
            first()
        );
    }
}